/* eslint-disable react/no-danger */
import React, {ReactNode} from 'react';

export const htmlContentRenderer = (content: string): ReactNode => {
  return <span dangerouslySetInnerHTML={{__html: content}} />;
};
